import { apiRequest, readJsonOrThrow } from "@/api/client";

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query.set(key, String(value));
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : "";
}

function encodeId(id) {
  return encodeURIComponent(String(id || ""));
}

export async function fetchNewsletters(session, params = {}) {
  const response = await apiRequest(`/momo/newsletters${buildQuery(params)}`, {
    session,
    includeContentType: false,
  });
  return readJsonOrThrow(response, "Failed to fetch newsletters");
}

export async function fetchNewsletter(session, id) {
  const response = await apiRequest(`/momo/newsletters/${encodeId(id)}`, {
    session,
    includeContentType: false,
  });
  return readJsonOrThrow(response, "Failed to fetch newsletter");
}

export async function createNewsletter(session, payload) {
  const response = await apiRequest("/momo/newsletters", {
    method: "POST",
    session,
    body: payload,
  });
  return readJsonOrThrow(response, "Failed to create newsletter");
}

export async function generateNewsletters(session, payload) {
  const response = await apiRequest("/momo/newsletters/generate", {
    method: "POST",
    session,
    body: payload,
  });
  return readJsonOrThrow(response, "Failed to generate newsletters");
}

export async function updateNewsletter(session, id, payload) {
  const response = await apiRequest(`/momo/newsletters/${encodeId(id)}`, {
    method: "PATCH",
    session,
    body: payload,
  });
  return readJsonOrThrow(response, "Failed to update newsletter");
}

export async function deleteNewsletter(session, id) {
  const response = await apiRequest(`/momo/newsletters/${encodeId(id)}`, {
    method: "DELETE",
    session,
    includeContentType: false,
  });
  return readJsonOrThrow(response, "Failed to delete newsletter");
}

export async function approveNewsletter(session, id) {
  const response = await apiRequest(`/momo/newsletters/${encodeId(id)}/approve`, {
    method: "POST",
    session,
  });
  return readJsonOrThrow(response, "Failed to approve newsletter");
}

export async function rejectNewsletter(session, id) {
  const response = await apiRequest(`/momo/newsletters/${encodeId(id)}/reject`, {
    method: "POST",
    session,
  });
  return readJsonOrThrow(response, "Failed to reject newsletter");
}

export async function scheduleNewsletter(session, id, payload) {
  const response = await apiRequest(`/momo/newsletters/${encodeId(id)}/schedule`, {
    method: "POST",
    session,
    body: payload,
  });
  return readJsonOrThrow(response, "Failed to schedule newsletter");
}

export async function fetchNewsletterPreview(session, id, params) {
  const response = await apiRequest(
    `/momo/newsletters/${encodeId(id)}/preview${buildQuery(params)}`,
    {
      session,
      includeContentType: false,
    }
  );
  return readJsonOrThrow(response, "Failed to fetch newsletter preview");
}

export async function sendNewsletterTest(session, id, payload) {
  const response = await apiRequest(`/momo/newsletters/${encodeId(id)}/send-test`, {
    method: "POST",
    session,
    body: payload,
  });
  return readJsonOrThrow(response, "Failed to send newsletter test");
}

export async function fetchNewsletterDeliveries(session, id, params = {}) {
  const response = await apiRequest(
    `/momo/newsletters/${encodeId(id)}/deliveries${buildQuery(params)}`,
    {
      session,
      includeContentType: false,
    }
  );
  return readJsonOrThrow(response, "Failed to fetch newsletter deliveries");
}

export async function fetchNewsletterSummary(session, id) {
  const response = await apiRequest(`/momo/newsletters/${encodeId(id)}/summary`, {
    session,
    includeContentType: false,
  });
  return readJsonOrThrow(response, "Failed to fetch newsletter summary");
}

export async function fetchNewsletterSummaries(session, newsletterIds = []) {
  const ids = (newsletterIds || []).map((id) => String(id || "").trim()).filter(Boolean);
  const response = await apiRequest(
    `/momo/newsletters/summaries${buildQuery({ newsletter_ids: ids.join(",") })}`,
    {
      session,
      includeContentType: false,
    }
  );
  return readJsonOrThrow(response, "Failed to fetch newsletter summaries");
}
